module.exports = __webpack_public_path__ + "img/001.346b3c50.png";